module.exports = __webpack_public_path__ + "fonts/Graphik-ExtralightItalic-Web.4edb5a1.woff";